import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskProcessDailyTerminalIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='none'
            stroke='currentColor'
            d='M17.0781 2.5C17.7097 2.5 18.1465 3.06133 18.1465 3.65137V4.88867H19.2949C19.974 4.8887 20.4012 5.48212 20.4014 6.08301V7.47266C20.4014 7.87696 20.2754 8.29332 20.0088 8.62988L18.9805 9.94531V14.0938H20.2422C20.997 14.0938 21.5 14.7755 21.5 15.4629L21.498 21V21.5H2.5V15.4629C2.5 14.7754 3.00319 14.0948 3.75781 14.0947H15.1572V9.94531L14.126 8.62598V8.625C13.8608 8.28934 13.7363 7.8738 13.7363 7.47168V6.08203C13.7365 5.4813 14.163 4.88794 14.8418 4.8877H16.0098V3.65137C16.0098 3.10486 16.4086 2.50003 17.0781 2.5ZM16.1377 17.7422H17.9795V17.0693H16.1377V17.7422ZM11.0791 17.7422H12.9209V17.0693H11.0791V17.7422ZM6.02051 17.7422H7.84277V17.46H7.8623V17.0693H6.02051V17.7422ZM16.1953 7.44922H17.9424V6.99414H16.1953V7.44922Z'
        />
    ),
})

TaskProcessDailyTerminalIcon.displayName = 'TaskProcessDailyTerminalIcon'
